<template>
  <SectionTemplate
    title="3D数字人全栈AI技术
    成就专业级3D数字人视频效果"
    class="page-main-what-makes-rendora-so-powerful"
  >
    <div class="marquee-container">
      <MarqueeSwiper :items="items" class="marquee-slide" />
    </div>
  </SectionTemplate>
</template>

<script lang="ts" setup>
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';
import MarqueeSwiper from '../../components/marquee-swiper.vue';

const academyLinks = {
  'real-avatar': 'https://www.youyan3d.com/blog/One-Click-Edit-Hyperrealistic-3D-avatars',
  'ai-video': 'https://www.youyan3d.com/blog/Easily-Make-Hollywood-Level-High-Quality-Videos',
  'ai-animation':
    'https://www.youyan3d.com/blog/Text-to-3D-Animation-Generate-AI-Digital-Human-Animation-by-Input-Script',
  'ai-tts':
    'https://www.youyan3d.com/blog/Supernatural-Multistyle-Text-to-Language-for-Professional-Scenarios',
  'ai-camera': 'https://www.youyan3d.com/blog/Text-to-3D-Camera-Movement-Auto-Generate',
  'ai-script': 'https://www.youyan3d.com/blog/AI-Text-to-Text-Solve-Professional-Script-Creation',
  'ai-clone': 'https://www.youyan3d.com/blog/Avatar-Cloning-and-Voice-Cloning.html',
};

const items = [
  {
    img: getFeUrl(
      '/youyan-platform/main/what-makes-rendora-so-powerful/3-1.png?x-oss-process=image/format,webp',
    ),
    title: '超写实3DAI数字人',
    desc: '依托AIGC智能建模&绑定技术，打造数千款超写实3D数字人形象，并支持个性化编辑。',
    bgcolor: 'rgba(240, 249, 255, 1)',
    link: academyLinks['real-avatar'],
    linkDesc: '从五官到妆造，一键编辑超写实3D数字人',
    imgAlt: '有言提供高质量的超写实数字人',
  },
  {
    img: getFeUrl(
      '/youyan-platform/main/what-makes-rendora-so-powerful/3-2.png?x-oss-process=image/format,webp',
    ),
    title: '文生3D数字人视频',
    desc: '无需拍摄与剪辑，只需上传脚本，AI一键生成专业级3D数字人视频。',
    bgcolor: 'rgba(236, 247, 245, 1)',
    link: academyLinks['ai-video'],
    linkDesc: '轻松制作好莱坞级高质量视频',
    imgAlt: '在有言中输入文案就可以生成3D数字人视频',
  },
  {
    img: getFeUrl(
      '/youyan-platform/main/what-makes-rendora-so-powerful/3-3.png?x-oss-process=image/format,webp',
    ),
    title: '文生3D动画',
    desc: '依托有言文生动作大模型，AI可根据文本语义生成自然流畅的表情与动作，让人物表达更生动。',
    bgcolor: 'rgba(240, 242, 245, 1)',
    link: academyLinks['ai-animation'],
    linkDesc: '输入脚本即可生成AI数字人动画',
    imgAlt: '有言可以基于语义识别让数字人更加生动',
  },
  {
    img: getFeUrl(
      '/youyan-platform/main/what-makes-rendora-so-powerful/3-4.png?x-oss-process=image/format,webp',
    ),
    title: '文生语音',
    desc: '输入文字，AI即可生成真人般超自然声音，还支持多语种、多音色输出，真实还原人物语态。',
    bgcolor: 'rgba(243, 244, 255, 1)',
    link: academyLinks['ai-tts'],
    linkDesc: 'AI生成语音能够适配各种专业场景',
    imgAlt: '在有言输入文字，AI即可生成像真人一样的声音',
  },
  {
    img: getFeUrl(
      '/youyan-platform/main/what-makes-rendora-so-powerful/3-5.png?x-oss-process=image/format,webp',
    ),
    title: '文生3D运镜',
    desc: '基于AI运镜能力，AI可自动生成专业多机位镜头语言，精准还原导播级拍摄效果。',
    bgcolor: 'rgba(255, 247, 229, 1)',
    link: academyLinks['ai-camera'],
    linkDesc: '有言能够AI生成多机位多角度的镜头',
    imgAlt: '有言能够在视频中自动生成多个机位和镜头',
  },
  {
    img: getFeUrl(
      '/youyan-platform/main/what-makes-rendora-so-powerful/3-6.png?x-oss-process=image/format,webp',
    ),
    title: '3D数字人克隆',
    desc: '只需上传一张照片和一段语音，即可快速生成专属3D数字人形象与音色。',
    bgcolor: 'rgba(255, 241, 240, 1)',
    imgAlt: '有言提供超低门槛的数字人克隆服务',
    link: academyLinks['ai-clone'],
    linkDesc: '快速克隆专属3D数字人',
  },
  {
    img: getFeUrl(
      '/youyan-platform/main/what-makes-rendora-so-powerful/3-7.png?x-oss-process=image/format,webp',
    ),
    title: 'AI脚本助手',
    desc: 'AI可根据创意生成完整脚本，或对已有内容进行局部润色与优化，提升脚本质量与产出效率。',
    bgcolor: 'rgba(240, 242, 245, 1)',
    link: academyLinks['ai-script'],
    linkDesc: 'AI文生文，搞定专业脚本创作',
    imgAlt: '有言提供AI优化视频脚本的功能',
  },
];
</script>

<style scoped lang="scss" src="./pc.scss" />
<style scoped lang="scss" src="./mobile.scss" />
